import { InputAdornment as MuiInputAdornment, } from '@mui/material';
export const InputAdornment = MuiInputAdornment;
